import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { NeutralColors, useTheme } from "@fluentui/react/lib/Theme";

export function useNotificationStyles() {
  const { effects, semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      notificationWrap: {
        position: `fixed`,
        bottom: -50,
        left: 5,
        right: 5,
        zIndex: 1000001,
        maxWidth: 1000,
        margin: `auto`,
        transition: `bottom 200ms ease-in`,
        visibility: `hidden`
      },
      visible: {
        bottom: 5,
        visibility: `visible`
      },
      title: {
        fontWeight: 600,
        marginRight: 10
      },
      messageBar: {
        minHeight: 50,
        marginTop: 3,
        justifyContent: `center`,
        boxShadow: effects.elevation64,
        borderRadius: effects.roundedCorner6
      },
      progressIndicator: {
        position: `absolute`,
        bottom: -2,
        left: 14,
        right: 10,
        zIndex: 1,
        ".ms-ProgressIndicator-progressTrack": {
          backgroundColor: NeutralColors.gray90
        },
        ".ms-ProgressIndicator-progressBar": {
          transition: `width 0.124s linear 0s`,
          backgroundColor: semanticColors.successBackground
        }
      },
      relative: {
        position: `relative`
      }
    }),
    [effects, semanticColors]
  );
}
